import { isPlatformBrowser } from '@angular/common';
import { Component, DestroyRef, inject, Inject, input, OnInit, PLATFORM_ID, signal } from '@angular/core';
import { KreuzfahrtFilters } from '@app/models/filtermodels/KreuzfahrtFilters';
import { CruiseFiltersService } from '@app/services/cruis/cruisefilters.service';
import { cruisesearchTypes, cruisegsPrice, cruisecabinCat, cruiselanguage, cruisemaxPass, cruisereiseDauer } from '../../tools/CruiseStatic';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

interface Item {
    name: string;
    function: string;
    index?: number,
    field?: string;
}

@Component({
    selector: 'clever-cruiseselectedfilters',
    templateUrl: './cruiseselectedfilters.component.html',
    styleUrls: ['./cruiseselectedfilters.component.scss'],
    standalone: false
})
export class CruiseselectedfiltersComponent implements OnInit {
    mode = input<string>('');
    type = input<string>('');
    isDisabled = input<boolean>(false);
    isBrowser = signal(false);
    list = signal<Item[]>([]);
    destroyRef = inject(DestroyRef);
    filter: KreuzfahrtFilters;
    constructor(
        @Inject(PLATFORM_ID) protected platformId: any,
        protected cruiseFilterService: CruiseFiltersService,
    ) {
        this.isBrowser.set(isPlatformBrowser(this.platformId));
    }

    ngOnInit(): void {
        if (this.isBrowser()) {
            this.initFilterSub();
        }
    }

    initFilterSub(): void {
        this.cruiseFilterService.getfilters$.pipe(
            takeUntilDestroyed(this.destroyRef)
        ).subscribe((filter: KreuzfahrtFilters) => {
            if (filter) {
                this.checkFilters(filter);
            }
        });
    }

    checkFilters(filter): void {
        this.list.set([]);
        this.filter = JSON.parse(JSON.stringify(filter));
        this.checlpromo();
        this.checkSearchType('cruisesuchetype', cruisesearchTypes);
        this.checkSearchType('cruiseduration', cruisereiseDauer);
        this.checkSearchType('cruiseboardlanguage', cruiselanguage);
        this.checkSearchType('cruisemaxprice', cruisegsPrice);
        this.checkSearchType('cruisecabincat', cruisecabinCat);
        this.checkSearchType('cruisemaxanzpass', cruisemaxPass);
        this.checkSearchTypeSchiff(filter.schiffes);
        this.cruiseFilterService.setExtraCount(this.list().length);
    }

    async resetAll() {
        this.cruiseFilterService.resetAllExtras();
    }

    checlpromo(): void {
        if (this.filter?.promo?.length > 0) {
            this.list().push({
                name: this.filter?.promo,
                function: 'removepromo',
            });
        }
    }

    async removepromo() {
        this.filter.promo = '';
        this.filter.pmc = '';
        this.cruiseFilterService.promo('');
        this.cruiseFilterService.pmc('');
        this.cruiseFilterService.changeUrl();
    }

    checkSearchType(type, array): void {
        if (this.filter?.[type]?.length > 0) {
            for (let i = 0; i < array.length; i++) {
                if (array[i].id === this.filter[type]) {
                    this.list().push({
                        name: array[i].name,
                        function: 'remove' + type,
                    });
                }
            }
        }
    }

    checkSearchTypeSchiff(array): void {
        for (let i = 0; i < array?.length; i++) {
            this.list().push({
                name: array[i].name,
                function: 'removeschiffes',
            });
        }
    }

    async removeschiffes() {
        this.filter.schiffes = [];
        this.cruiseFilterService.schiffes([]);
        this.cruiseFilterService.changeUrl();
    }

    async removecruisesuchetype() {
        this.filter.cruisesuchetype = '';
        this.cruiseFilterService.cruisesuchetype('', true);
    }

    async removecruiseduration() {
        this.filter.cruiseduration = '';
        this.cruiseFilterService.cruiseduration('', true);
    }

    async removecruisemaxprice() {
        this.filter.cruisemaxprice = '';
        this.cruiseFilterService.cruisemaxprice('', true);
    }

    async removecruisemaxanzpass() {
        this.filter.cruisemaxanzpass = '';
        this.cruiseFilterService.cruisemaxanzpass('', true);
    }

    async removecruisecabincat() {
        this.filter.cruisecabincat = '';
        this.cruiseFilterService.cruisecabincat('', true);
    }

    async removecruiseboardlanguage() {
        this.filter.cruiseboardlanguage = '';
        this.cruiseFilterService.cruiseboardlanguage('', true);
    }
}
